<template>
  <span>
    <el-button
      :type="triggerType"
      size="mini"
      @click="openDialog"
    >{{ triggerText }}</el-button>

    <el-dialog
      title="支付资质下金额"
      :visible.sync="visible"
      width="520px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="pq-dialog-body">
        <el-form label-position="top" size="mini">
          <el-form-item label="支付时间区间" required>
            <el-date-picker
              v-model="payRange"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-form>

        <div style="margin: 0 0 12px;">
          <el-button type="primary" size="mini" :loading="loading" @click="onQuery">查询</el-button>
        </div>

        <el-table
          v-if="results.length > 0"
          :data="results"
          border
          size="mini"
        >
          <el-table-column prop="account" label="资质账号" min-width="120"></el-table-column>
          <el-table-column prop="qualName" label="资质名称" min-width="160"></el-table-column>
          <el-table-column prop="totalMoney" label="金额合计" width="100"></el-table-column>
        </el-table>
        <div v-else-if="hasQueried && !loading" class="pq-empty">暂无数据</div>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { getGameUserInfoPayQualifications } from '@/api/vipQualityTest';

export default {
  name: 'PayQualCell',
  props: {
    row: { type: Object, default: () => ({}) },
    // 触发按钮的样式（列表里走 text 链接、抽屉里走 primary 按钮）
    triggerType: { type: String, default: 'text' },
    triggerText: { type: String, default: '查询' },
  },
  data() {
    return {
      visible: false,
      loading: false,
      hasQueried: false,
      payRange: null,
      results: [],
      requestSeq: 0,
    };
  },
  methods: {
    openDialog() {
      // 打开时不清空已有结果，方便用户参考上次；每次切换行时由 watch 重置
      this.visible = true;
    },
    async onQuery() {
      if (!Array.isArray(this.payRange) || this.payRange.length !== 2 || !this.payRange[0] || !this.payRange[1]) {
        this.$message.warning('请选择支付时间区间');
        return;
      }
      const seq = ++this.requestSeq;
      this.loading = true;
      try {
        const res = await getGameUserInfoPayQualifications({
          platform: this.row.platform,
          app_key: this.row.appkey,
          user_id: this.row.userId,
          role_id: this.row.roleId,
          pay_time_start: this.payRange[0],
          pay_time_end: this.payRange[1],
        });
        if (seq !== this.requestSeq) return;
        if (res && res.data && res.data.code === 200) {
          this.results = Array.isArray(res.data.data) ? res.data.data : [];
          this.hasQueried = true;
        } else {
          this.$message.error((res && res.data && res.data.message) || '查询失败');
        }
      } catch (e) {
        if (seq !== this.requestSeq) return;
        this.$message.error('查询失败');
      } finally {
        if (seq === this.requestSeq) this.loading = false;
      }
    },
  },
  watch: {
    // 切换到不同 row 时清空上一次结果
    'row.roleId'() {
      this.payRange = null;
      this.results = [];
      this.hasQueried = false;
    },
  },
};
</script>

<style lang="less" scoped>
.pq-dialog-body {
  font-size: 12px;
}
.pq-empty {
  padding: 12px;
  text-align: center;
  color: #8c8c8c;
  border: 1px dashed #e8e8e8;
  border-radius: 4px;
}
</style>
